(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["afaf-luxe"] && !Shopify.designMode) return;
  try {
    (function(){document.querySelectorAll('.dw-afaf').forEach(function(root){var hidden=root.querySelector('[data-variant-id]'),price=root.querySelector('[data-main-price]'),add=root.querySelector('[data-add-to-cart]');root.querySelectorAll('input[name="dw-afaf-variant"]').forEach(function(input){input.addEventListener('change',function(){root.querySelectorAll('.dw-afaf__variant').forEach(function(el){el.classList.remove('is-selected')});input.closest('.dw-afaf__variant').classList.add('is-selected');hidden.value=input.value;price.textContent=input.dataset.price;add.disabled=input.dataset.available!=='true'})});var q=root.querySelector('[data-qty]'),m=root.querySelector('[data-qty-minus]'),p=root.querySelector('[data-qty-plus]');if(m&&p&&q){m.addEventListener('click',function(){q.value=Math.max(1,(parseInt(q.value,10)||1)-1)});p.addEventListener('click',function(){q.value=(parseInt(q.value,10)||1)+1})}})})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
